import { Create } from 'react-admin';
import { AdsActionsForm } from './AdsActions.Form';
import { BackButton } from '../../../helperComponents/BackButton';
import { transformAdsActionCreate } from '../../../../helpers/adsActionsHelpers';

export const AdsActionsCreate = (props) => {
  return (
    <>
      <BackButton path="/ads_actions" />
      <span className="h4">Propose Action</span>
      <Create {...props} title=" " redirect="show" transform={transformAdsActionCreate}>
        <AdsActionsForm />
      </Create>
    </>
  );
};
